export default function PinkCursor() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 46 52" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.78125 3.34326L12.3638 48.6564L21.4283 29.418L42.5639 27.0591L2.78125 3.34326Z" fill="#FF89C2" stroke="black" stroke-width="5.30401" stroke-linejoin="round" />
        </svg>

    )
}